import { Collapse, HStack, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { formatUtcDateToDateString } from '@utils/formatDate';
import { columnTypeToFormatter } from './columns';

const BookRow = ({ columns, id, row, expandedRow, setExpandedRow }) => {
  if (!row) return null;

  const isExpanded = id === expandedRow;

  return (
    <>
      <Tr
        cursor="pointer"
        width="100%"
        _hover={{ bg: 'gray.50' }}
        onClick={() => {
          setExpandedRow((prev) => (prev === id ? null : id));
        }}
      >
        {columns.map((column) => {
          const value = column.render ? column.render(row, isExpanded) : row[column.key];

          const formatter = column.type && columnTypeToFormatter[column.type];
          const formattedValue = formatter ? formatter(value) : value;

          return (
            <Td
              flex={1}
              fontWeight="500 !important"
              key={column.label}
              sx={{
                ' *': {
                  fontWeight: 500,
                },
              }}
            >
              {formattedValue}
            </Td>
          );
        })}
      </Tr>
      <Tr>
        <Td colSpan={columns.length} p={0}>
          <HStack width="100%" bg="gray.50" px={[2, 2, '50px']}>
            <Collapse
              in={isExpanded}
              transition={{
                exit: { duration: 0.3 },
                enter: { duration: 0.3 },
              }}
              style={{
                width: 'fit-content',
              }}
              unmountOnExit
            >
              <TableContainer width="100%" pt={2} pb={6}>
                <Table px={8} w="100%">
                  <Thead
                    sx={{
                      ' th': {
                        color: 'primary.500 !important',
                        pt: 4,
                        pb: 2,
                      },
                    }}
                  >
                    <Th>Carrier</Th>
                    <Th>Status</Th>
                    <Th>Status Reason</Th>
                    <Th>Plan</Th>
                    <Th>Plan Type</Th>
                    <Th>Effective Date</Th>
                    <Th>Signature Date</Th>
                    <Th>Last Updated</Th>
                  </Thead>
                  <Tbody>
                    {row.plans.map((plan, index) => (
                      <Tr key={index} py={1}>
                        <Td>{plan.carrier}</Td>
                        <Td>{plan.status}</Td>
                        <Td>{plan.statusReason}</Td>
                        <Td>
                          {plan.planName} {plan.cmsId}
                        </Td>
                        <Td>{plan.planType}</Td>
                        <Td>{formatUtcDateToDateString(plan.effectiveDate)}</Td>
                        <Td>{formatUtcDateToDateString(plan.signatureDate)}</Td>
                        <Td>{formatUtcDateToDateString(plan.updatedAt)}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Collapse>
          </HStack>
        </Td>
      </Tr>
    </>
  );
};

export default BookRow;
